<template>
  <AutoDialogDrawer placement="centre" modal dismissible @close="$emit('close')">
    <template #title>{{ translate('Create New Login Policy') }}</template>
    <p>
      {{ translate('Are you sure you want to create a new login policy?') }}
    </p>
    <p v-if="!!loginPolicyStore.loginPolicies">
      {{
        translate(
          'You already have an existing login policy. Instead of starting from scratch, you can create a new policy based on an existing one to copy over its settings and continue editing from there.',
        )
      }}
    </p>
    <template #buttons>
      <BootstrapButton name="cancel" variant="secondary" @click="$emit('close')">
        {{ translate('Cancel') }}
      </BootstrapButton>
      <BootstrapButton name="create" variant="primary" @click="emit('confirm')">
        {{ translate('Create') }}
      </BootstrapButton>
    </template>
  </AutoDialogDrawer>
</template>

<script setup lang="ts">
import {useLocalisation} from '@/composables/useLocalisation';

const {translate} = useLocalisation();

const loginPolicyStore = useLoginPolicyStore();
const emit = defineEmits<{close: []; confirm: []}>();
</script>
